import { DOMParser, DOMSerializer } from 'prosemirror-model';
export var createHTMLTransformer = function (schema) {
    var parser = DOMParser.fromSchema(schema);
    var serializer = DOMSerializer.fromSchema(schema);
    return {
        parse: function (html) {
            var _a;
            var template = document.createElement('template');
            template.innerHTML = html.trim();
            if (!((_a = template.content) === null || _a === void 0 ? void 0 : _a.firstChild)) {
                throw new Error('Error parsing HTML input');
            }
            return parser.parse(template.content);
        },
        serialize: function (doc) {
            var template = document.createElement('template');
            template.content.appendChild(serializer.serializeFragment(doc.content));
            return template.innerHTML;
        },
    };
};
